import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessUserList: [],
  platformUserList: [],
};

const accessUserSlice = createSlice({
  name: "accessUserSlice",
  initialState,
  reducers: {
    accessUserAction: (state, action) => {
      state.accessUserList = action.payload.accessUserList;
    },
    platformUserAction: (state, action) => {
      state.platformUserList = action.payload.platformUserList;
    },
    resetStateAccessUserAction: () => initialState,
  },
});

export const { accessUserAction, platformUserAction, resetStateAccessUserAction } = accessUserSlice.actions;

export default accessUserSlice.reducer;
